import * as Service from 'types/service';
import { Box } from '@material-ui/core';
import { Divider } from '@tocktix/pantry';
import { EventAttributesActionLocation } from 'utils/analytics/amplitudeEventConstants';
import { PrintChitSource } from 'constants/PrinterConstants';
import { ViewMode } from 'routes/authenticated/app/bookings/CalendarAndServiceRoute';
import { displayStatus, generateStateSelectorStatus } from 'utils/partyUtils';
import PartyPanelStateSelector from 'components/service/party-panel/PartyPanelStateSelector';
import PartyPopoverActionButton from 'components/service/party/partyPopover/PartyPopoverActionButton';
import PartyPopoverDescription from 'components/service/party/partyPopover/PartyPopoverDescription';
import PartyPopoverFooter from 'components/service/party/partyPopover/PartyPopoverFooter';
import PartyPopoverHeader from 'components/service/party/partyPopover/PartyPopoverHeader';

interface Props {
  isReadOnly: boolean;
  party: Service.Party;
  printOnSeat: boolean;
  secondaryStates: Service.StateGroupingMap;
  viewMode: ViewMode;
  onCancelPurchase(party?: Service.Party): void;
  onClose(): void;
  onEditReservation(actionLocation?: EventAttributesActionLocation): void;
  onFinishSeatedPartiesAtTablesAndSeatNewParty(tableIds: number[], party: Service.Party): void;
  onOpenParty(): void;
  onPrintChit(party: Service.Party | undefined, source: PrintChitSource): void;
  onRemoveWalkIn(): void;
  onSelectParty(party: Service.Party): void;
  onUpdatePartyState(party: Service.Party, state: string, secondaryState: string | null): void;
}

const PartyPopoverLegacy: React.FC<Props> = ({
  isReadOnly,
  party,
  printOnSeat,
  secondaryStates,
  viewMode,
  onCancelPurchase,
  onClose,
  onEditReservation,
  onFinishSeatedPartiesAtTablesAndSeatNewParty,
  onOpenParty,
  onPrintChit,
  onRemoveWalkIn,
  onSelectParty,
  onUpdatePartyState,
}) => {
  return (
    <>
      <PartyPopoverHeader
        lastNameFirstName={party.lastNameFirstName}
        partySize={party.partySize}
        openPartyFullPanel={onOpenParty}
      />
      <PartyPopoverDescription
        expectedReservationTime={party.expectedReservationTime ?? undefined}
        status={displayStatus(party)}
      />
      <Box mb={1}>
        <PartyPanelStateSelector
          isDisabled={isReadOnly}
          party={party}
          status={generateStateSelectorStatus(party)}
          secondaryStates={secondaryStates}
          handleUpdatePartyState={onUpdatePartyState}
          position="top"
          onPrintChit={onPrintChit}
          printOnSeat={printOnSeat}
        />
      </Box>
      <Box mb={1}>
        <PartyPopoverActionButton
          isReadOnly={isReadOnly}
          party={party}
          viewMode={viewMode}
          onClose={onClose}
          onFinishSeatedPartiesAtTablesAndSeatNewParty={
            onFinishSeatedPartiesAtTablesAndSeatNewParty
          }
          handleSelectParty={onSelectParty}
        />
      </Box>
      <Box mb={1}>
        <Divider />
      </Box>
      <PartyPopoverFooter
        party={party}
        isReadOnly={isReadOnly}
        onCancelPurchase={onCancelPurchase}
        onClose={onClose}
        onEditReservation={onEditReservation}
        handleSelectParty={onSelectParty}
        handleRemoveWalkIn={onRemoveWalkIn}
        viewMode={viewMode}
      />
    </>
  );
};

export default PartyPopoverLegacy;
